import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './pages/App';
import './index.css';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { LoadScript } from '@react-google-maps/api';

const theme = createTheme({
  palette: {
    primary: {
      main: '#003769',
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <LoadScript googleMapsApiKey='AIzaSyAfzu3WZlywETMoYYZfooSjQEjPEb5hj-c'>
        <App />
      </LoadScript>
    </ThemeProvider>
  </React.StrictMode>
);
